import { Injectable } from "@angular/core";
import { NgbDatepickerI18n, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
@Injectable()
export class I18n {
  language = "es"; // Establece el idioma en español
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }

  override getWeekdayLabel(weekday: number): string {
    return this.I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }

  override getWeekLabel(): string {
    return this.I18N_VALUES[this._i18n.language].weekLabel;
  }

  override getMonthShortName(month: number): string {
    return this.I18N_VALUES[this._i18n.language].months[month - 1];
  }

  override getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  override getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }

  private I18N_VALUES: {
    [key: string]: { weekdays: string[]; months: string[]; weekLabel: string };
  } = {
    es: {
      weekdays: ["Lu", "Ma", "Mi", "Ju", "Vi", "Sá", "Do"],
      months: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],
      weekLabel: "sem",
    },
  };
}
